import { render } from "./BackupLogListFiltroDialog.vue?vue&type=template&id=17159b4b"
import script from "./BackupLogListFiltroDialog.vue?vue&type=script&lang=js"
export * from "./BackupLogListFiltroDialog.vue?vue&type=script&lang=js"

import exportComponent from "/app/app-cliente/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__